module.exports = __webpack_public_path__ + "img/certificate3.4f37b96d.png";